<template>
  <div class="modal fade" id="giftCodeUpdateModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered  w-[500px] ">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Update Gift Code</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body ">
                  <div >
                      <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                          Gift Code:
                          <v-text-field v-model="giftCode" variant="outlined" density="compact" :disabled="true" 
                              rounded="0">
                              <template v-slot:append-inner>
                                <v-icon icon="mdi-refresh" class=" cursor-pointer" @click="generateCouponCode(6)"></v-icon>
                              </template>
                          </v-text-field>  
                      </div>
                      <div class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                          Gift Amount: 
                          <v-text-field v-model="price" variant="outlined" density="compact" rounded="0"
                              type="number" style=""></v-text-field>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary"
                      @click="handleUpdate">Update</button>
              </div>
          </div>
      </div>
  </div>
</template>


<script setup>
import { ref, watchEffect, defineProps, defineEmits } from 'vue';
import { useGiftCodeStore } from "@/stores"

const gitCodeStore = useGiftCodeStore();

const props = defineProps({
    item: {
        type: Object, // Assuming user object has a name property
        required: true
    },
});

const buttonDisableFlag = ref(false);
const giftCode = ref('');
const price = ref(0)
const emit = defineEmits(['inInput', 'submit'])

watchEffect(() => {
    if(props.item){
        giftCode.value = props.item.giftCode;
        price.value = props.item.price;
    }
})

const handleUpdate = () => {
  const packageRequest = {giftCode: giftCode.value, 
                          price: price.value };

  buttonDisableFlag.value = true;
  // Send FormData to server
  gitCodeStore.updateGiftCode(packageRequest).then(() => {
    gitCodeStore.loadGiftCodes();
    buttonDisableFlag.value = false;
    emit('close');
  });
};
function generateCouponCode(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // Allowed characters
    let tempCouponCode = '';
    
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        tempCouponCode += characters[randomIndex];
    }

    giftCode.value = tempCouponCode;
}

</script>
